import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer style={footerStyle}>
      {/* 1. Legal Links */}
      <div style={linksStyle}>
          <Link to="/contact" style={linkTextStyle}>Contact Us</Link>
          <span style={{color: '#dfe1e6', margin: '0 10px'}}>|</span>
          <Link to="/terms" style={linkTextStyle}>Terms of Service</Link>
          <span style={{color: '#dfe1e6', margin: '0 10px'}}>|</span>
          <Link to="/privacy" style={linkTextStyle}>Privacy Policy</Link>
      </div>

      {/* 2. Copyright Info */}
      <p style={copyrightStyle}>
          &copy; {new Date().getFullYear()} LuxerAssess. All rights reserved.
      </p>
    </footer>
  );
}

// --- Inline Styles for Consistency ---
const footerStyle = {
    textAlign: 'center', 
    padding: '40px 20px', 
    backgroundColor: '#f4f5f7', 
    borderTop: '1px solid #dfe1e6',
    width: '100%',
    boxSizing: 'border-box',
    marginTop: 'auto', // Pushes the footer to the bottom of the flex container (App or App-header)
};

const linksStyle = {
    fontSize: '0.9rem', 
    marginBottom: '15px', 
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
};

const linkTextStyle = {
    color: '#505f79', 
    textDecoration: 'none', 
    margin: '0 10px'
};

const copyrightStyle = {
    color: '#97a0af', 
    fontSize: '0.85rem', 
    margin: 0
};

export default Footer;